module.exports = __webpack_public_path__ + "img/SEO_SVG.07a67cae.svg";